<template>
  <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
    <v-expansion-panel>
      <v-expansion-panel-header color="#007BC3" hide-actions
        ><b class="white--text text-center">{{
          subtitle
        }}</b></v-expansion-panel-header
      >
      <v-expansion-panel-content class="mt-6">
        <v-row>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-medium">
              <span>INSTRUÇÕES</span>
            </div>
            <v-divider />
          </v-col>
          <v-col cols="12">
            <div class="text-instructions text-body-2" v-html="message"></div>
          </v-col>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-medium">
              <span>IDENTIFICAÇÃO DO FORNECEDOR</span>
            </div>
            <v-divider />
          </v-col>
        </v-row>
        <slot name="content"></slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  data: () => ({
    panel: [0],
    disabled: false
  }),
  props: {
    subtitle: {
      type: String
    },
    message: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.text-instructions {
  background-color: #eeeeee;
  border-radius: 10px;
  padding: 10px 10px 1px 10px;
}
.title {
  letter-spacing: 0.1666666667em !important;
}
</style>
